import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {UsersListWrapper} from './users-list'
import {JazariUsersList} from './jazari-users/JazariUsersList'
import {useAuth} from '../auth'
import {branchesOf} from '../common/actingBranch'

const SupplierUsersPage: React.FC = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()
  // Mart v2: a shop supplier's admin also adds the Jazari pickers for its branches.
  const showJazari = currentUser?.role === 'admin' && branchesOf(currentUser).length > 0
  const [tab, setTab] = useState<'hisbah' | 'jazari'>('hisbah')

  if (!showJazari) {
    return <UsersListWrapper />
  }

  return (
    <>
      <div className='d-flex overflow-auto h-55px mb-6'>
        <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
          {([['hisbah', 'USERS.TAB_HISBAH'], ['jazari', 'JAZARI_USERS.TAB']] as const).map(([key, label]) => (
            <li key={key} className='nav-item'>
              <button
                type='button'
                className={`nav-link btn btn-link text-active-primary me-6 ${tab === key ? 'active' : ''}`}
                onClick={() => setTab(key)}
              >
                {intl.formatMessage({id: label})}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {tab === 'hisbah' ? <UsersListWrapper /> : <JazariUsersList />}
    </>
  )
}

export {SupplierUsersPage}
